import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = { class: "input-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Amount", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " Used to check whether the player has at least the specified amount of money (through Vault) ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[1] || (_cache[1] = $event => (_ctx.inputTransformer($event, _ctx.action.amount))),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.amount = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.action.amount,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_3
      ])
    ]),
    _hoisted_4
  ]))
}